import type { FC } from 'react';
import React, { useState } from 'react';
import { MdOutlineClose } from 'react-icons/md';

import styles from './index.module.scss';

export type ImageElementProps = {
  image: string;
};

const ImageElement: FC<ImageElementProps> = ({ image }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <img
        src={image}
        className={`${styles.image} ${open ? styles.open : ''}`}
        alt="feedback message image"
        onClick={() => setOpen(true)}
      />
      {open && (
        <button className={styles.imageButton} onClick={() => setOpen(false)}>
          <MdOutlineClose />
        </button>
      )}
    </>
  );
};

export default ImageElement;
